var map = {
	"./container_line.svg": 357,
	"./fairEthical.svg": 358,
	"./highQuality.svg": 359,
	"./leaf.svg": 360,
	"./onDemand.svg": 361,
	"./point leave.svg": 362,
	"./rentLease.svg": 363,
	"./repairRedesign.svg": 364,
	"./secondHand.svg": 365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 356;